/**
    * @description      :
    * @author           : verdentum
    * @group            :
    * @created          : 10/08/2021 - 09:54:01
    *
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 10/08/2021
    * - Author          : verdentum
    * - Modification    :
**/
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { apiUrl } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  response:any;
  apiLink = apiUrl+'/api/';

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private toastr: ToastrService
  ) { }

  //===========get all currency=================
  async getAllCurrency() {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/get_all_currency', {}, {headers: headers}).toPromise().then(response => {

      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }
      return this.response.currencies;
    });
  }

  //===========get all county=================
  async getAllCounties() {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/get_all_county', {}, {headers: headers}).toPromise().then(response => {

      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }
      return this.response.counties;
    });
  }


  //===============add basic Info ===================//
  async addBasicInfo(basicDetails:any) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    console.log(basicDetails);

    return this.http.post(this.apiLink+'project/add', basicDetails, {headers: headers}).toPromise().then(response => {
     // console.log(response)
      this.response = response;
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return true;
      }
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false;
    });
  }


  //===========get all projects=================
  async getAllProjects(org_code = null, filter = {}) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/get_all', {org_code: org_code, filter: filter}, {headers: headers}).toPromise().then(response => {

      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }
      return this.response.projects;
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false;
    });
  }

  //===========get all projects for Task Mgt Dashboard / analysis=================
  /**
   * Same endpoint as `getAllProjects`, but returns the portfolio SUMMARY alongside the page.
   *
   * A separate method on purpose: `getAllProjects()` returns a bare array and a dozen screens
   * (fishbone, variance, the dashboards, the pickers) destructure it as one. Changing its shape to
   * carry the summary would break every one of them for the sake of a single caller.
   *
   * The summary is computed server-side over the WHOLE filtered set, not the LIMIT-50 page — see
   * the comment on `/project/get_all`. The Portfolio screen's KPIs were previously counting the
   * rows loaded so far, so an org with 200 projects was told it had 50.
   */
  async getProjectPortfolio(org_code = null, filter = {}): Promise<{ projects: any[]; summary: any } | false> {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });

    return this.http.post(this.apiLink+'project/get_all', {org_code: org_code, filter: filter}, {headers: headers}).toPromise().then((response: any) => {
      if(response.status == 0) {
        this.toastr.error(response.msg, 'Error!', { timeOut: 5000 });
        return false as const;
      }
      return { projects: response.projects || [], summary: response.summary || null };
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false as const;
    });
  }

  /**
   * EXPORT — computed on the server, over the WHOLE filtered portfolio.
   *
   * Deliberately NOT built from the component's `projects[]`. That array holds only what infinite
   * scroll has loaded, so exporting from it produced a file that silently contained the first 50
   * projects of 200 and said nothing about the other 150.
   *
   * @param scope      'portfolio' — every project the current filter matches
   *                   'project'   — one project's full M&E chain (indicators, periods, activities, team)
   * @param project_id required when scope is 'project'
   */
  async exportProjects(
    org_code: string | null = null,
    filter: any = {},
    scope: 'portfolio' | 'project' = 'portfolio',
    project_id: number | null = null,
  ): Promise<any | false> {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });

    return this.http.post(
      this.apiLink + 'project/export',
      { org_code, filter, scope, project_id },
      { headers },
    ).toPromise().then((response: any) => {
      if (response.status == 0) {
        this.toastr.error(response.msg, 'Error!', { timeOut: 5000 });
        return false as const;
      }
      return response;
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false as const;
    });
  }

  /**
   * PROJECT DETAILS — one call per tab, fetched on first open.
   *
   * The details screen is tabbed and each tab is lazy. Somebody who opens a project to check its
   * end date should not pay for the per-period indicator matrix, the activity rollup and the task
   * board. Only `header` runs on load.
   *
   * @param section 'header' | 'logframe' | 'activities' | 'locations' | 'tasks'
   */
  async getProjectDetail(section: string, org_code: string | null, project_id: number): Promise<any | false> {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });

    return this.http.post(
      this.apiLink + `project/detail/${section}`,
      { org_code, project_id },
      { headers },
    ).toPromise().then((response: any) => {
      if (response.status == 0) {
        this.toastr.error(response.msg, 'Error!', { timeOut: 5000 });
        return false as const;
      }
      return response;
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false as const;
    });
  }

  async getAllProjectsTaskDash(org_code = null, filter = {}) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/get_all_proj_dash', {org_code: org_code, filter: filter}, {headers: headers}).toPromise().then(response => {

      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }
      return this.response.projects;
    });
  }

  //===========get all projects for public sharable dashboard=================
  async getAllProjectsShareDash(org_code = null, filter = {}) {
      let userDetails = await this.authService.getUserDetails(),
      token = userDetails.token ? userDetails.token : '';
  
      // Create header and append JWT token
      let headers = new HttpHeaders({
        'Authorization': `Bearer: ${token}`
      });
      headers.append('Authorization', token);
  
      return this.http.post(this.apiLink+'lookup/get_all_sharedashboard', {org_code: org_code, filter: filter}, {headers: headers}).toPromise().then(response => {
  
        this.response = response;
        if(this.response.status == 0) {
          this.toastr.error(this.response.msg, 'Error!', {
            timeOut: 5000,
          });
          return false;
        }
        return this.response.projects;
      });
  }

  //===============map project===================//
  async mapProject(mapDetails:any) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/map', mapDetails, {headers: headers}).toPromise().then(response => {
     // console.log(response)
      this.response = response;
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return true;
      }
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false;
    });
  }

  //===============map location project===================//
  async mapLocation(mapDetails:any) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/map_location', mapDetails, {headers: headers}).toPromise().then(response => {
     // console.log(response)
      this.response = response;
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return true;
      }
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false;
    });
  }

  //===========get project and template details=================
  async getProjectAndTemplateDetails(proj_id) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/get_details', {id: proj_id}, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }

      return {
        project: this.response.project,
        template: this.response.template
      };
    });
  }
  //===============get project details===================//
  async getProjectDetails(proj_id) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/get_project_dash', {id: proj_id}, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }

      return {
        project: this.response.project,
        sdg: this.response.sdg
      };
    });
  }

  //===============get project details for public shareable dashboard===================//
  async getProjectDetailsShareDash(proj_id) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'lookup/get_project_dash_share_dash', {id: proj_id}, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }

      return {
        project: this.response.project,
        sdg: this.response.sdg
      };
    });
  }


  /**
   * F8 — Start / End date check before a project is saved. The Form.io date picker parses typed
   * text loosely ("01/01/2026" becomes "0102-08-26") and says nothing, so this catches it with a
   * clear message. Same rules as the server (verdentum_mean_server/services/projectDates.js):
   * a real YYYY-MM-DD date, year 2000–2100, End not before Start. An empty date is left to the
   * template's own `required` setting. Returns the error message, or null when the dates are fine.
   */
  projectDateError(projData: any): string | null {
    const part = (raw: any): string | null => {
      if (raw === null || raw === undefined) return null;
      const s = String(raw).trim();
      return s ? s.split(/[T ]/)[0] : null;
    };
    const check = (ymd: string, label: string): string | null => {
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd);
      const d = m ? new Date(Date.UTC(+m[1], +m[2] - 1, +m[3])) : null;
      // A real calendar date: 2026-02-30 rolls over to March, so the parts no longer match.
      if (!m || !d || d.getUTCFullYear() !== +m[1] || d.getUTCMonth() !== +m[2] - 1 || d.getUTCDate() !== +m[3]) {
        return `${label} "${ymd}" is not a valid date. Pick it from the calendar or type it as YYYY-MM-DD.`;
      }
      if (+m[1] < 2000 || +m[1] > 2100) {
        return `${label} "${ymd}" looks wrong — the year must be between 2000 and 2100. Pick it from the calendar or type it as YYYY-MM-DD.`;
      }
      return null;
    };
    const start = part(projData?.startDateTime);
    const end = part(projData?.endDateTime);
    const err = (start && check(start, 'Start date')) || (end && check(end, 'End date'));
    if (err) return err;
    if (start && end && end < start) return `End date (${end}) cannot be before Start date (${start}).`;
    return null;
  }

  /**
   * BUG-009 (BATCH 109) — the project template is each org's own copy, so its rules are fixed here
   * at render time instead of rewriting 100+ stored templates:
   *   • End date: "must be after start" → "cannot be before start" (a one-day project is allowed,
   *     owner 3 Oct — same rule as the server and the Excel import)
   *   • Budget: never negative
   */
  relaxProjectTemplate(components: any[]): any[] {
    const walk = (list: any[]) => (list || []).forEach((c: any) => {
      if (!c || typeof c !== 'object') return;
      if (c.key === 'endDateTime' && c.validate && typeof c.validate.custom === 'string' && c.validate.custom.includes('isAfter')) {
        c.validate.custom =
          "var minDate = moment(data.startDateTime);\n" +
          "var maxDate = moment(data.endDateTime);\n" +
          "valid = (!data.startDateTime || !data.endDateTime || !maxDate.isBefore(minDate, 'day')) ? true : 'End date cannot be before start date'";
      }
      if (c.key === 'budget' && c.type === 'number') {
        c.validate = { ...(c.validate || {}), min: 0 };
      }
      if (Array.isArray(c.components)) walk(c.components);
      if (Array.isArray(c.columns)) c.columns.forEach((col: any) => walk(col?.components));
      if (Array.isArray(c.rows)) c.rows.forEach((row: any) => Array.isArray(row) && row.forEach((cell: any) => walk(cell?.components)));
    });
    walk(components);
    return components;
  }

  /** BUG-009: refused before sending — negative budget; asked — a one-day project. */
  private projectPreChecks(projData: any): boolean {
    const b = projData?.budget;
    if (b !== null && b !== undefined && b !== '' && Number(b) < 0) {
      this.toastr.error('Budget cannot be negative.', 'Check the budget', { timeOut: 8000 });
      return false;
    }
    const part = (v: any) => (v ? String(v).slice(0, 10) : '');
    const start = part(projData?.startDateTime), end = part(projData?.endDateTime);
    if (start && end && start === end) {
      return window.confirm('Start and end are the same day — this project will have a single one-day period '
        + '(no separate Baseline and Endline). If this is one event of a larger programme, consider logging it '
        + 'as an activity in that project instead.\n\nContinue with a one-day project?');
    }
    return true;
  }

  /** BUG-009: the server found another project of this organisation with the same name — a warning, not a block. */
  private confirmDuplicateName(msg: string): boolean {
    return window.confirm(`${msg}\n\nSave this one with the same name anyway?`);
  }

  //===============add project details===================//
  async addProject(projData, projDetails, confirmed = false) {
    const dateError = this.projectDateError(projData);
    if (dateError) {
      this.toastr.error(dateError, 'Check the project dates', { timeOut: 8000 });
      return false;
    }
    if (!confirmed && !this.projectPreChecks(projData)) return false;

    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    let data = {
      form_id: projDetails.id,
      user_id: userDetails.user.id,
      org_code: projDetails.org_code,
      form_data: JSON.stringify(projData),
      allow_duplicate_name: confirmed,
    }
    return this.http.post(this.apiLink+'project/add', data, {headers: headers}).toPromise().then(response => {
     // console.log(response)
      this.response = response;
      if(this.response.status === 2 && this.response.code === 'DUPLICATE_NAME') {
        return this.confirmDuplicateName(this.response.msg) ? this.addProject(projData, projDetails, true) : false;
      }
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return this.response.project_id;
      }
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false;
    });
  }

  async updateProject(projData, projDetails, proj_id, confirmed = false) {
    const dateError = this.projectDateError(projData);
    if (dateError) {
      this.toastr.error(dateError, 'Check the project dates', { timeOut: 8000 });
      return false;
    }
    if (!confirmed && !this.projectPreChecks(projData)) return false;

    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';
    
    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    let data = {
      proj_id: proj_id,
      form_data: JSON.stringify(projData),
      allow_duplicate_name: confirmed,
    }
    return this.http.post(this.apiLink+'project/update', data, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status === 2 && this.response.code === 'DUPLICATE_NAME') {
        return this.confirmDuplicateName(this.response.msg) ? this.updateProject(projData, projDetails, proj_id, true) : false;
      }
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }

      this.toastr.success(this.response.msg, 'Success!', {
        timeOut: 5000,
      });
      return true;
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return true;
    });
  }

  async getAllMappingData(proj_id = null) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';
    
    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/get_all_mapping', {project: proj_id}, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }
      return this.response.mapping;
    });
  }

  async deleteMapping(mappedData:any) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';
    
    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/delete_mapping', { proj_id: mappedData.proj_id, part_id: mappedData.part_id }, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }

      this.toastr.success(this.response.msg, 'Success!', {
        timeOut: 5000,
      });
      return true;
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return true;
    });
  }

  //===========get measurement modules=================
  async getGlobalMeasurementModules() {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/get_global_measurement', {}, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }

      return this.response.modules;
    });
  }

  async addMeasurementModule(measurementData) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';
    
    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);
    
    return this.http.post(this.apiLink+'project/update_measurement', measurementData, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }
      
      this.toastr.success(this.response.msg, 'Success!', {
        timeOut: 5000,
      });
      return true;
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return true;
    });
  }

  //===========get logframe=================
  async getLogframe(request) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'logframe/get_all', request, {headers: headers}).toPromise().then(response => {

      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }
      return this.response.impacts;
    });
  }

  //===========get logframe for public sharebale dashboard=================
  async getLogframeShareDash(request) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'lookup/get_all_logframe_share_dash', request, {headers: headers}).toPromise().then(response => {

      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }
      return this.response.impacts;
    });
  }

  //===============get activity metrics details===================//
  async getProjectActivityMetrics(proj_id) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/get_project_activity_metrics', {id: proj_id}, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }

      return this.response.project;
     
    });
  }

  //===============get activity metrics details for public sharebale dashboard===================//
  async getProjectActivityMetricsShareDash(proj_id) {
      let userDetails = await this.authService.getUserDetails(),
      token = userDetails.token ? userDetails.token : '';
  
      // Create header and append JWT token
      let headers = new HttpHeaders({
        'Authorization': `Bearer: ${token}`
      });
      headers.append('Authorization', token);
  
      return this.http.post(this.apiLink+'lookup/get_project_activity_metrics_share_dash', {id: proj_id}, {headers: headers}).toPromise().then(response => {
        this.response = response;
        if(this.response.status == 0) {
          this.toastr.error(this.response.msg, 'Error!', {
            timeOut: 5000,
          });
          return false;
        }
  
        return this.response.project;
       
      });
  }

  //===============get activity map details===================//
  async getProjectActivityMap(proj_id) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'project/get_project_activity_map', {id: proj_id}, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }

      return this.response.project;
     
    });
  }

  //===============get activity map details for public sharebale dashboard===================//
  async getProjectActivityMapShareDash(proj_id) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'lookup/get_project_activity_map_share_dash', {id: proj_id}, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }

      return this.response.project;
     
    });
  }

  //===============get activity map details for public sharebale dashboard===================//
  async getShareDashUrl(org_code, proj) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'publicsharedash/public_link', {org_code: org_code, proj: proj}, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }

      return this.response.link;
     
    });
  }

  //enable log-frmae in project
  /**
   * S4-08 / triage #11 — `enabled` was added so a model can be turned OFF, not only on.
   * It defaults to true, so every existing caller is unchanged. The server treats false as
   * a soft retire (status = 0), never a delete.
   */
  async enableLogFrameProject(proj_id, measurement_id, org_code, enabled = true) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    let request = {
      proj_id: proj_id,
      measurement_id: measurement_id,
      org_code: org_code,
      enabled: enabled
    };

    return this.http.post(this.apiLink+'project/update_project_logfrmae', request, {headers: headers}).toPromise().then(response => {
     // console.log(response)
      this.response = response;
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return true;
      }
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false;
    });
  }

  //===========import excel=================
  async importExcelData(jsonData, projDetails) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink + 'project/import', {jsonData: jsonData, form_id: projDetails.id}, { headers: headers }).toPromise().then(response => {
      this.response = response;
      if (this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return true;
      }
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false;
    });
  }

}
